import { z } from 'zod';
import { ErrorCode } from '../../../../shared/error-codes';
import { BaseErrorSchema } from '../../../../shared/error.schema';
import { SuperAdminUserSchema } from '../../entities/superadmin-user';
import { SupportedLanguageSchema } from '../../../../shared/language.schema';
/**
 * Invite SuperAdmin User Request Schema
 * POST /api/v2/superadmin-users/invite
 * Creates a new superadmin user and sends an invitation email
 */ export const InviteSuperAdminUserRequestSchema = z.object({
    firstName: z.string().min(1, ErrorCode.FIELD_REQUIRED),
    lastName: z.string().min(1, ErrorCode.FIELD_REQUIRED),
    email: z.string().email('Valid email is required'),
    language: SupportedLanguageSchema.optional()
});
/**
 * Invite SuperAdmin User Response Schema
 * Returned on successful user invitation
 * Contains the created superadmin user object
 */ export const InviteSuperAdminUserResponseSchema = z.object({
    user: SuperAdminUserSchema
});
/**
 * Invite SuperAdmin User Error Schema
 * Returned when user invitation fails
 */ export const InviteSuperAdminUserErrorSchema = BaseErrorSchema;

//# sourceMappingURL=invite-superadmin-user.schema.js.map